function formatDate(timestamp) {


let date = new Date(timestamp);
let hours = date.getHours();
if (hours < 10){
  hours = `0${hours}`;
}
 
let minutes = date.getMinutes();
if (minutes < 10){
  minutes = `0${minutes}`;
}

let days = 
["Sunday", 
"Monday", 
"Tuesay", 
"Wednesday", 
"Thursday", 
"Friday", 
"Saturday"];
let day =days[date.getDay()];


return `${day} ${hours}:${minutes}`;
} 

function formatDay(timestamp) {
let date = new Date (timestamp * 1000);
let day = date.getDay();
let days= ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

 return days[day];
}
function displayForecast(response) {
  let forecast = response.data.daily; 

  let forecastElement = document.querySelector("#forecast");
  
  let forecastHTML = `<div class="row">`;
  
  forecast.forEach(function (forecastDay, index) {
   
 
  forecastHTML = forecastHTML + 
  `
    <div class="col-3">
      <div class="weather-forecast-date">
     ${formatDay(forecastDay.dt)}    </div> 
      <img 
      src="http://openweathermap.org/img/wn/${forecastDay.weather[0].icon}@2x.png"
      alt=""
      width="42"/>
      <div class-="weather-forecast-temperatures">
      <span class="weather-forecast-max">${Math.round(forecastDay.temp.max)}°</span>
      <span  class="weather-forecast-min">${Math.round(forecastDay.temp.min)}°</span>
     
   
    </div>
   </div>


`;
    
});

forecastHTML = forecastHTML + `</div>`;
forecastElement.innerHTML = forecastHTML;
}

function getForecast(coordinates) {

  let apKey = "2719487ee0b6b73046038ab7b2d43815";
  let apUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${coordinates.lat}&lon=${coordinates.lon}&appid=${apKey}&units=imperial`;
  axios.get(apUrl).then(displayForecast);

}
function showTemp(response) {
  let temperature = Math.round(response.data.main.temp);
  let city = response.data.name;
  let hum = response.data.main.humidity;
  let windy = Math.round(response.data.wind.speed);
 
  fahrenheitTemperature = response.data.main.temp;
  
  let temperatureElement = document.querySelector("#temperature");
  temperatureElement.innerHTML = `${temperature}`;

  let h3 = document.querySelector("h3");
  h3.innerHTML = `${city}`;
  
  let dateElement= document.querySelector("h5");
  dateElement.innerHTML = formatDate(response.data.dt * 1000); 
  
  let iconElement= document.querySelector("#icon");
  iconElement.setAttribute("src",`http://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`);
  iconElement.setAttribute("alt", response.data.weather[0].description);
  
  
  let descriptionElement = document.querySelector("#description");
  descriptionElement.innerHTML = response.data.weather[0].description;
 
  let humElement = document.querySelector("#hum");
  humElement.innerHTML = `${hum}%`;

  let windElement = document.querySelector("#wind");
  windElement.innerHTML = `${windy} mph`;
  
  getForecast(response.data.coord);

}



function currentLocation(position) { 
  let api = "2719487ee0b6b73046038ab7b2d43815";
  let uni = "imperial";
  let lat = position.coords.latitude;
  let long = position.coords.longitude;
  let apiUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${long}&appid=${api}&units=${uni}`;

  axios.get(apiUrl).then(showTemp);
}



function getsearch(city) {
  let apiKey = "2719487ee0b6b73046038ab7b2d43815";
  let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=imperial`;
  axios.get(apiUrl).then(showTemp);
}


let currentButton = document.querySelector("#location-button");
currentButton.addEventListener("click", getCurrentLocation);

function getCurrentLocation(event) {
  event.preventDefault();
}


function search(event) {
  event.preventDefault();

  let searchInput = document.querySelector("#search-text-input");
  let h3 = document.querySelector("h3");
  h3.innerHTML = `${searchInput.value}`;

  let apiKey = "2719487ee0b6b73046038ab7b2d43815";
  let unit = "imperial";
  let url = `https://api.openweathermap.org/data/2.5/weather?q=${searchInput.value}&appid=${apiKey}&units=${unit}`;

  axios.get(url).then(showTemp);
}

let form = document.querySelector("#search-form");
form.addEventListener("submit", search);

navigator.geolocation.getCurrentPosition(currentLocation);
getsearch("New York");



